import { useEffect, useRef } from "react";
import { getExcelProgressById, getSeriesImportProgress } from "../api/bulk-upload-api";

export const useExcelPolling = (id, setSelectedExcel, excelList) => {
  const pollingInterval = useRef(null);

  const getExcelFileDetailsById = async () => {
    try {
      const selectedFile = excelList?.find((f) => f.id === id);
      const isSeries = selectedFile?.upload_type === "series_excel";

      const response = isSeries
        ? await getSeriesImportProgress(id)
        : await getExcelProgressById(id);
      const data = response?.data?.data;

      if (data) {
        setSelectedExcel(data);

        if (!data.should_continue_polling && pollingInterval.current) {
          clearInterval(pollingInterval.current);
          pollingInterval.current = null;
        }
      }
    } catch (error) {
      console.error("Polling error:", error);
    }
  };

  useEffect(() => {
    if (!id) return;

    getExcelFileDetailsById();

    pollingInterval.current = setInterval(() => {
      getExcelFileDetailsById();
    }, 3000);

    return () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current);
        pollingInterval.current = null;
      }
    };
  }, [id]);
};